'use es6';

import enviro from 'enviro';
import { List } from 'immutable';
import { SUB_APPS } from 'reporting-data/tsTypes/subAppTypes';
import { getHybridSRVSubAppTabs, isSubAppHybridSRVReport } from 'sales-analytics-lib/utils/report-hybrid-srv-sub-app-data';
import { hasAccessToTab } from 'sales-analytics-lib/utils/tabAccess';
import { templatesBySubAppKey } from 'sales-analytics-lib/utils/get-report-config';
import { RCH_CSAT_SURVEY_ID_QA, RCH_CSAT_SURVEY_ID_PROD } from '../config/collectionHomes';
const getKeysForGetReportConfig = (subAppKey, gates, scopes) => {
  if (isSubAppHybridSRVReport(subAppKey)) {
    return getHybridSRVSubAppTabs(subAppKey, scopes, gates);
  }
  //fallback for subapps not defined in REPORT_HYBRID_SRV_SUB_APP_DATA
  return [subAppKey];
};
export const getHasAccessToSubApp = (subApp, analyticsPermissions) => {
  if (!analyticsPermissions.get(subApp)) {
    return true;
  }
  return analyticsPermissions.getIn([subApp, 'isVisible']) && analyticsPermissions.getIn([subApp, 'accessAllowed']);
};
export const getHasAccessToTab = (subApp, tab, gates, scopes) => {
  return hasAccessToTab(subApp, tab, gates, scopes);
};
export const getHomesFeedbackSurvey = () => {
  return enviro.isProd() ? RCH_CSAT_SURVEY_ID_PROD : RCH_CSAT_SURVEY_ID_QA;
};
export const containsActiveChild = (item, activeChild) => {
  const myChildren = item.get('children', List());
  return myChildren.some(child => child.get('id') === activeChild || containsActiveChild(child, activeChild));
};
export const getRealmTemplateKeys = (templateIdFromUrl, gates, scopes) => {
  const subAppKey = SUB_APPS[templateIdFromUrl];
  if (subAppKey) {
    const keys = getKeysForGetReportConfig(subAppKey, gates, scopes);
    return keys.map(key => templatesBySubAppKey.get(key));
  }
  return [templateIdFromUrl];
};
export const getRealmTemplateKey = (templateIdFromUrl, gates, scopes) => {
  return getRealmTemplateKeys(templateIdFromUrl, gates, scopes)[0];
};
export const OLD_ACTIVITIES_AND_LEADS_SUB_APPS_TO_NEW = {
  [SUB_APPS.callOutcomes]: {
    newSubApp: SUB_APPS.calls,
    tabKey: 'callOutcomes'
  },
  [SUB_APPS.prospectEngagement]: {
    newSubApp: 'sequences'
  },
  [SUB_APPS.meetingOutcomes]: {
    newSubApp: SUB_APPS.meetings,
    tabKey: 'meetingOutcomes'
  },
  [SUB_APPS.taskOutcomes]: {
    newSubApp: SUB_APPS.tasks,
    tabKey: 'taskOutcomes'
  },
  [SUB_APPS.leadFunnel]: {
    newSubApp: SUB_APPS.leads,
    tabKey: 'leads'
  },
  [SUB_APPS.leadResponseTime]: {
    newSubApp: SUB_APPS.leads,
    tabKey: 'leadResponseTime'
  }
};